module.exports = __webpack_public_path__ + "842b0c1fc7a5cf9d993edbbeae087fcc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/clarity-ui-icons.svg
// module id = 1562
// module chunks = 0